import { Link } from 'react-router-dom';

export interface Crumb {
  name: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1 text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={item.name} className="flex items-center gap-1">
            {item.path && !isLast ? (
              <Link
                to={item.path}
                className="text-foreground-500 hover:text-primary-600 transition-colors"
              >
                {item.name}
              </Link>
            ) : (
              <span className={isLast ? 'text-foreground-900 font-medium' : 'text-foreground-500'}>
                {item.name}
              </span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-300" />}
          </span>
        );
      })}
    </nav>
  );
}